// extracted by mini-css-extract-plugin
export default {"todoCard":"todo-list_todoCard__T1oFA","itemForm":"todo-list_itemForm__OF9dA"};